/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Edge/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import Video from 'DesignSystem/Video/react'



/** @type {import('Simple/types.js').View} */
export default function Edge({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/Tabs/AiRecorder/Content/State/Error/Content/Guides/Edge",
  src
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<Video
  viewPath={`${viewPath}/Video`}
 marginTop={dtSpaceS}
 src={src}
 autoPlay={true}
 controls={true}
 muted={true}
 playsInline={true}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 text="1. Click the icon to the left of the 'admin.greyfinch.com' URL in the address bar."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="2. Find 'Microphone' and choose 'Allow' or 'Ask'."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="3. Close the permissions dialog and refresh the page."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="4. If you selected 'Ask', grant permission when prompted during recording (e.g., when using the three vertical dots in the widget)."
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="5. Greyfinch should now have access to your microphone."
/>
{children}
</React.Fragment>)
}